/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrderInfoVo1 } from './OrderInfoVo1';
import {
    OrderInfoVo1FromJSON,
    OrderInfoVo1FromJSONTyped,
    OrderInfoVo1ToJSON,
    OrderInfoVo1ToJSONTyped,
} from './OrderInfoVo1';
import type { ParcelImgVo } from './ParcelImgVo';
import {
    ParcelImgVoFromJSON,
    ParcelImgVoFromJSONTyped,
    ParcelImgVoToJSON,
    ParcelImgVoToJSONTyped,
} from './ParcelImgVo';
import type { OrderInfoForInboundPictureNoDataVo } from './OrderInfoForInboundPictureNoDataVo';
import {
    OrderInfoForInboundPictureNoDataVoFromJSON,
    OrderInfoForInboundPictureNoDataVoFromJSONTyped,
    OrderInfoForInboundPictureNoDataVoToJSON,
    OrderInfoForInboundPictureNoDataVoToJSONTyped,
} from './OrderInfoForInboundPictureNoDataVo';
import type { GoodsInfoOrderInfoForInboundPictureVo1 } from './GoodsInfoOrderInfoForInboundPictureVo1';
import {
    GoodsInfoOrderInfoForInboundPictureVo1FromJSON,
    GoodsInfoOrderInfoForInboundPictureVo1FromJSONTyped,
    GoodsInfoOrderInfoForInboundPictureVo1ToJSON,
    GoodsInfoOrderInfoForInboundPictureVo1ToJSONTyped,
} from './GoodsInfoOrderInfoForInboundPictureVo1';

/**
 * 
 * @export
 * @interface OrderInfoForInboundPictureVo
 */
export interface OrderInfoForInboundPictureVo {
    /**
     * 快递单id
     * @type {number}
     * @memberof OrderInfoForInboundPictureVo
     */
    parcelId?: number;
    /**
     * 
     * @type {OrderInfoForInboundPictureNoDataVo}
     * @memberof OrderInfoForInboundPictureVo
     */
    orderInfoForInboundPictureNoData?: OrderInfoForInboundPictureNoDataVo;
    /**
     * 订单信息列表
     * @type {Array<OrderInfoVo1>}
     * @memberof OrderInfoForInboundPictureVo
     */
    orderInfoList?: Array<OrderInfoVo1>;
    /**
     * 商品信息列表
     * @type {Array<GoodsInfoOrderInfoForInboundPictureVo1>}
     * @memberof OrderInfoForInboundPictureVo
     */
    goodsInfoList?: Array<GoodsInfoOrderInfoForInboundPictureVo1>;
    /**
     * 快递图片列表
     * @type {Array<ParcelImgVo>}
     * @memberof OrderInfoForInboundPictureVo
     */
    parcelImgList?: Array<ParcelImgVo>;
}

/**
 * Check if a given object implements the OrderInfoForInboundPictureVo interface.
 */
export function instanceOfOrderInfoForInboundPictureVo(value: object): value is OrderInfoForInboundPictureVo {
    return true;
}

export function OrderInfoForInboundPictureVoFromJSON(json: any): OrderInfoForInboundPictureVo {
    return OrderInfoForInboundPictureVoFromJSONTyped(json, false);
}

export function OrderInfoForInboundPictureVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderInfoForInboundPictureVo {
    if (json == null) {
        return json;
    }
    return {
        
        'parcelId': json['parcelId'] == null ? undefined : json['parcelId'],
        'orderInfoForInboundPictureNoData': json['orderInfoForInboundPictureNoData'] == null ? undefined : OrderInfoForInboundPictureNoDataVoFromJSON(json['orderInfoForInboundPictureNoData']),
        'orderInfoList': json['orderInfoList'] == null ? undefined : ((json['orderInfoList'] as Array<any>).map(OrderInfoVo1FromJSON)),
        'goodsInfoList': json['goodsInfoList'] == null ? undefined : ((json['goodsInfoList'] as Array<any>).map(GoodsInfoOrderInfoForInboundPictureVo1FromJSON)),
        'parcelImgList': json['parcelImgList'] == null ? undefined : ((json['parcelImgList'] as Array<any>).map(ParcelImgVoFromJSON)),
    };
}

export function OrderInfoForInboundPictureVoToJSON(json: any): OrderInfoForInboundPictureVo {
    return OrderInfoForInboundPictureVoToJSONTyped(json, false);
}

export function OrderInfoForInboundPictureVoToJSONTyped(value?: OrderInfoForInboundPictureVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'parcelId': value['parcelId'],
        'orderInfoForInboundPictureNoData': OrderInfoForInboundPictureNoDataVoToJSON(value['orderInfoForInboundPictureNoData']),
        'orderInfoList': value['orderInfoList'] == null ? undefined : ((value['orderInfoList'] as Array<any>).map(OrderInfoVo1ToJSON)),
        'goodsInfoList': value['goodsInfoList'] == null ? undefined : ((value['goodsInfoList'] as Array<any>).map(GoodsInfoOrderInfoForInboundPictureVo1ToJSON)),
        'parcelImgList': value['parcelImgList'] == null ? undefined : ((value['parcelImgList'] as Array<any>).map(ParcelImgVoToJSON)),
    };
}

